export default function CTASection() {
  return (
    <section className="relative bg-background-50 py-16 md:py-20 overflow-hidden">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Ready to Shop Smart?
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mb-8">
            Access the full Pandabuy Spreadsheet collection on our main site — thousands of verified products organized by category.
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer shadow-lg shadow-primary-500/20"
          >
            Buy It Now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>

      <div className="mt-12 flex items-center gap-4 md:gap-6 overflow-hidden opacity-40">
        <div className="flex-shrink-0 h-16 md:h-20 w-32 md:w-40 rounded-2xl bg-background-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Close%20up%20of%20tan%20leather%20loafer%20shoe%20on%20a%20warm%20cream%20surface%20with%20visible%20stitching%20detail%20and%20leather%20grain%20soft%20natural%20lighting%20minimalist%20product%20detail%20photography%20clean%20shallow%20depth%20of%20field%20neutral%20aesthetic%20high%20detail&width=320&height=160&seq=cta-strip-v2-01&orientation=landscape"
            alt="Leather loafer product"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 h-16 md:h-20 w-32 md:w-40 rounded-2xl bg-background-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Close%20up%20detail%20of%20a%20sage%20green%20knit%20sweater%20texture%20visible%20yarn%20and%20ribbed%20pattern%20on%20a%20warm%20cream%20surface%20soft%20natural%20lighting%20minimalist%20product%20detail%20photography%20clean%20shallow%20depth%20of%20field%20neutral%20aesthetic%20high%20detail&width=320&height=160&seq=cta-strip-v2-02&orientation=landscape"
            alt="Knit sweater product"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 h-16 md:h-20 w-32 md:w-40 rounded-2xl bg-background-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20structured%20olive%20canvas%20backpack%20with%20leather%20zipper%20pull%20and%20brass%20hardware%20on%20a%20warm%20cream%20surface%20soft%20natural%20lighting%20minimalist%20product%20detail%20photography%20clean%20shallow%20depth%20of%20field%20neutral%20aesthetic%20high%20detail&width=320&height=160&seq=cta-strip-v2-03&orientation=landscape"
            alt="Canvas backpack product"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 h-16 md:h-20 w-32 md:w-40 rounded-2xl bg-background-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Close%20up%20detail%20of%20a%20camel%20wool%20coat%20fabric%20showing%20the%20woven%20texture%20and%20folded%20lapel%20on%20a%20warm%20cream%20surface%20soft%20natural%20lighting%20minimalist%20fabric%20detail%20photography%20clean%20shallow%20depth%20of%20field%20neutral%20aesthetic%20high%20detail&width=320&height=160&seq=cta-strip-v2-04&orientation=landscape"
            alt="Wool coat product"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 h-16 md:h-20 w-32 md:w-40 rounded-2xl bg-background-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20minimalist%20gold%20watch%20with%20a%20brown%20leather%20strap%20on%20a%20warm%20cream%20surface%20soft%20natural%20lighting%20highlighting%20the%20watch%20face%20and%20leather%20grain%20clean%20product%20detail%20photography%20shallow%20depth%20of%20field%20neutral%20aesthetic%20high%20detail&width=320&height=160&seq=cta-strip-v2-05&orientation=landscape"
            alt="Minimalist watch product"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
        <div className="flex-shrink-0 h-16 md:h-20 w-32 md:w-40 rounded-2xl bg-background-200 overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20pair%20of%20classic%20tortoise%20shell%20sunglasses%20with%20warm%20amber%20lenses%20on%20a%20cream%20linen%20surface%20soft%20natural%20lighting%20creating%20subtle%20reflections%20minimalist%20product%20detail%20photography%20clean%20shallow%20depth%20of%20field%20neutral%20aesthetic%20high%20detail&width=320&height=160&seq=cta-strip-v2-06&orientation=landscape"
            alt="Sunglasses product"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}